export default {
  logOut: 'Cerrar sesión',
  title: 'Negocios',
  businessCard: {
    lastPost: 'Última publicación:',
    dueDate: 'Fecha de vencimiento:',
    noDueDate: 'Sin fecha de vencimiento',
  },
};
